
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import useAnalytics from "@/hooks/use-analytics";

const faqs = [
  {
    question: "Como faço login na plataforma da Dr.Cash?",
    answer: "Acesse https://portal.drcash.com.br, clique em \"Acessar Portal\" e insira seu e-mail e senha cadastrados para acessar a plataforma."
  },
  {
    question: "Esqueci minha senha de acesso à plataforma, como redefinir?",
    answer: "Clique em \"Esqueci minha senha\" na tela de login do portal, informe o e-mail cadastrado e siga as orientações recebidas por e-mail para criar uma nova senha."
  },
  {
    question: "Como agendar treinamento?",
    answer: "Acesse https://l1nq.com/drcash-treinamento ou, se já tiver acesso ao novo portal, utilize a aba \"Treinamento\"."
  },
  {
    question: "Quais os canais de atendimento do BV?",
    answer: "- CAC: 3003 7888 (capitais), 0800 777 2828 (demais localidades)\n- WhatsApp: (11) 3003-1616\n- Site: https://minha.bv.com.br/login/\n- App: https://www.bv.com.br/app-bv"
  },
  {
    question: "Como renegociar parcelas em atraso?",
    answer: "O paciente deve solicitar a renegociação diretamente nos canais Parcelex:\n- E-mail: atendimento@parcelex.com.br\n- WhatsApp: (21) 98625-3551\n- Renegociação: pagamentos@parcelex.com.br\n- Central de Ajuda: ajuda.parcelex.com.br"
  },
  {
    question: "Como solicitar segunda via do carnê Parcelex?",
    answer: "Acesse https://boletos.parcelex.com.br, insira o CPF do paciente e baixe o carnê. Também disponível pelo app Parcelex (Android/iOS)."
  }
];

const FaqSection = () => {
  const { trackButtonClick } = useAnalytics();

  const handleSeeMoreClick = () => {
    trackButtonClick("ver_mais_perguntas", "atendimento_faq_section");
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-3xl">
        <h2 className="text-3xl font-bold text-drcash-maastricht-blue mb-8 text-center">
          Perguntas Frequentes
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left font-medium text-drcash-maastricht-blue">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 whitespace-pre-line">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        <div className="mt-10 flex justify-center">
          <Button
            asChild
            variant="default"
            className="bg-drcash-caribbean-green text-white hover:bg-drcash-caribbean-green/90"
            onClick={handleSeeMoreClick}
          >
            <Link to="/faq">
              Ver mais perguntas
              <ChevronRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
